<template>
  <div class="py-4 container-fluid">
    <GridRow class=" row">
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <argon-button :to="{ name: 'Create Penilaian Kinerja' }" :isRouteLink="true"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah {{ ((title ?? this.$route?.meta?.title) ?? this.$route?.name) }}</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :xs="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :md="12">
                <div class="d-flex align-items-center justify-content-start gap-2 w-100">
                  <div class="d-flex justify-content-start w-100 gap-2">
                    <InputGroup class="m-0 filter">
                      <template v-slot:prepend>
                        <i class="fas fa-search" aria-hidden="true"></i>
                      </template>
                      <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                        placeholder="Cari nama penilaian kinerja..." style="border-right: 1px solid #d2d6da!important;">
                    </InputGroup>

                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.unitkerja_id"
                        :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                        option-value="id"
                        option-text="name"
                        placeholder="Semua Unit Kerja"
                      />
                    </FormGroup>
  
                    <FormGroup class="m-0 filter">
                      <model-list-select
                        class="form-control"
                        v-model="params.jabatan_id"
                        :list="jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                        option-value="id"
                        option-text="name"
                        placeholder="Semua Jabatan"
                      />
                    </FormGroup>
                  </div>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <list-view :thead="['Nama Penilaian', 'Jabatan', 'Status', 'Aksi']">
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="5" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td class="font-weight-bold">{{ item?.title ?? "-" }}</td>
                <!-- <td><div class="column-truncate">{{ item?.unitkerja ?? "-" }}</div></td> -->
                <!-- <td><div class="column-truncate">{{ item?.jabatan ?? "-" }}</div></td> -->
                <td width="420"><div class="text-wrap">{{ item?.jabatan ?? "-" }}</div></td>
                <td>
                  <argon-badge v-if="item.status == 'active'" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status == 'inactive'" color="danger">Non Aktif</argon-badge>
                </td>
                <td class="align-middle">
                  <!-- <VueTripleDots></VueTripleDots> -->
                  <ThreeDotsMenu>
                    <!-- <router-link :to="{ name: 'Update Penilaian Kinerja', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Edit</router-link> -->
                    <router-link :to="{ name: 'Detail Penilaian Kinerja', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Detail</router-link>
                    <button @click.prevent="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <ArgonPagination v-if="metaData.total_item" :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </list-view>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import FormGroup from '@/components/FormGroup.vue';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import ListView from '@/components/ListView.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import KpiApi from '@/repository/api/KpiApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from '@/repository/api/JabatanApi';
import ArgonPagination from '@/components/ArgonPagination.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import MetaSection from "@/components/MetaSection.vue";


export default {
  name: "tables",
  components: {
    MetaSection,
    CardComponent,
    InputGroup,
    FormGroup,
    ArgonBadge,
    ArgonButton,
    ThreeDotsMenu,
    ListView,
    GridRow,
    GridCol,
    ArgonPagination,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      unitkerja: [],
      jabatan: [],
      params: {
        limit: "",
        keyword: "",
        unitkerja_id: "",
        jabatan_id: "",
        page: 1,
      },
      metaData: {},
    };
  },
  async mounted() {
    await this.getData();
    await this.getJabatan();
    await this.getUnitKerja();
  },
  watch: {
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    // 'params.keyword': {
    //   handler: async function () {
    //     this.params.page = 1;
    //     // this.params.jabatan_id = "";
    //     // await this.getKpi();
    //     await this.getData();
    //   },
    //   deep: true,
    // },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
    'params.unitkerja_id': {
      handler: async function () {
        this.params.page = 1;
        // this.params.jabatan_id = "";
        // await this.getJabatan();
        await this.getData();
      },
      deep: true,
    },
    'params.jabatan_id': {
      handler: async function () {
        this.params.page = 1;
        await this.getData();
      },
      deep: true,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({page: "all", status: "active"}).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.params.jabatan_id = "";
        this.unitkerja = [];
      });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      let params = {};
      // if (this.params.unitkerja_id != "") {
      //   params = {
      //     unitkerja_id: this.params.unitkerja_id,
      //   }
        params["active"] = "1"
        params["page"] = "all"
        await JabatanApi.getbyparam(params).then((response) => {
          this.jabatan = response.data;
        }).catch(() => {
          this.jabatan = [];
        })
      // } else {
      //   this.jabatan = [];
      // }
      this.$store.state.loading = false;
    },
    async searchKeyword() {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650);
    },
    // async getData(keyword = "") {
    async getData() {
      await this.getDataAll();

      // if (keyword.length <= 0) {
      //   await this.getDataAll();
      //   if (this.params.unitkerja_id) {
      //     await this.getJabatan();
      //   }
      // }
      // else if (keyword.length >= 2) {
      //   this.timer = setTimeout(async () => {
      //     await this.getDataAll();
      //   }, 1500)
      // }
    },
    async getDataAll() {
      this.$store.state.loading = true;
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = JSON.parse(JSON.stringify(this.params[key]))
        }
      });
      await KpiApi.getByParamsNew(params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = 1;
        }
        this.data = [];
      });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await KpiApi.deleteNew(id)
            .then(() => {
              this.getData();
              this.$swal({
                icon: "success",
                title: "Berhasil"
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.message || 'Something wrong, please try again.',
              });
            });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
